module.exports = __webpack_public_path__ + "img/企事业餐饮运营托管服务2.7ba66af6.jpg";